import React from 'react';
import { Image, MaskImage } from '@/pages/reports/components/ui';
import SmileWhite from '@/assets/icons/SmileWhite.svg';
import Arrow from '@/assets/images/Arrow.svg?url';
import Live from '@/assets/images/Live.svg?url';
import { HeroProps } from './HeroDesktop';
import { resolveHeroBackgroundColor, resolveHeroTextColor } from '@/pages/reports/utils/heroColors';
import { useReportI18n } from '@/pages/reports/i18n';

export const HeroMobile: React.FC<HeroProps> = ({
  date,
  edition,
  topCenterImage,
  topRightImage,
  bottomLeftImage,
  backgroundColor,
  textColor,
  logoLinks = [],
}) => {
  const { t, showLatamSeal } = useReportI18n();
  const resolvedBackgroundColor = resolveHeroBackgroundColor(backgroundColor);
  const resolvedTextColor = resolveHeroTextColor(textColor);

  return (
    <div
      className="relative w-full overflow-hidden"
      style={{ backgroundColor: resolvedBackgroundColor }}
    >
      <div className="container mx-auto relative px-4 pt-8">
        {topCenterImage && (
          <div className="flex justify-center mb-4 relative z-10">
            <Image
              src={topCenterImage}
              alt=""
              className="h-auto w-auto max-w-full"
            />
          </div>
        )}
        <div className="flex flex-col gap-2 relative z-10">
          <h1 
            className="font-normal text-[80px] font-['Times_New_Roman']"
            style={{ color: resolvedTextColor }}
          >
            Culture
          </h1>
          <div className="flex items-center gap-2 w-full">
            <MaskImage src={Arrow} color={resolvedTextColor} className="flex-2 h-16 w-24" ariaHidden />
            <div className="flex flex-1 justify-center">
              <Image
                src={topRightImage}
                alt=""
                className="h-auto w-auto max-w-full shrink-0 rounded-sm"
              />
            </div>
          </div>
          <h1 
            className="font-normal text-[80px] font-['Times_New_Roman']"
            style={{ color: resolvedTextColor }}
          >
            Monitor
          </h1>
          <div className="flex items-center gap-2">
            <img 
              src={SmileWhite}
              alt=""
              className="w-[60px] h-auto"
            />
            <div className="flex flex-col items-start">
              <MaskImage
                src={Live}
                color={resolvedTextColor}
                className="w-[150px] h-16"
                ariaLabel="Live"
              />
              {showLatamSeal && (
                <span
                  className="font-['Times_New_Roman'] text-[16px] leading-none tracking-[0.18em] mt-1 whitespace-nowrap"
                  style={{ color: resolvedTextColor }}
                >
                  {t('hero.latam')}
                </span>
              )}
            </div>
          </div>
          <div 
            className="text-xs mt-4"
            style={{ color: resolvedTextColor }}
          >
            {date} - {t('hero.edition')}: {edition}
          </div>
          {logoLinks.length > 0 && (
            <div className="flex flex-wrap items-center justify-start gap-3 mt-4">
              {logoLinks.map((item, index) => {
                const content = (
                  <Image
                    key={index}
                    src={item.imageUrl}
                    alt=""
                    className="h-auto w-auto max-w-full"
                  />
                );
                return item.link ? (
                  <a
                    key={index}
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center"
                  >
                    {content}
                  </a>
                ) : (
                  <span key={index} className="flex items-center">
                    {content}
                  </span>
                );
              })}
            </div>
          )}
          <div className="flex justify-center">
            <Image
              src={bottomLeftImage}
              alt=""
              className="h-auto w-auto max-w-full rounded-sm"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

